import {createSelector} from '@ngrx/store';
import {AppState} from '../app.state';
import {FacilityState} from './facility.state';

const selectFacilities = (state: AppState) => state.facilities;

export const selectFacilityList = createSelector(selectFacilities, (state: FacilityState) => state.facilities);

export const selectActiveFacility = createSelector(selectFacilities, (state: FacilityState) => state.activeFacility);
